// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ボタンデザイン（ToolSettings.module.cssからコピー） */
.ListManager_button__I5HIN {
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 18px;
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
}
.ListManager_button__I5HIN:hover {
  background: #1565c0;
}
.ListManager_bulkDeleteButton__wQBHb {
  background: #e53935;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 18px;
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  margin-left: 12px;
}
.ListManager_bulkDeleteButton__wQBHb:disabled {
  background: #f5bdbd;
  color: #fff;
  cursor: not-allowed;
}
.ListManager_bulkDeleteButton__wQBHb:hover:not(:disabled) {
  background: #b71c1c;
}
.ListManager_deleteButton__yPXTr {
  background: #e53935;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 4px 14px;
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  margin-left: 8px;
}
.ListManager_deleteButton__yPXTr:hover {
  background: #b71c1c;
}
.ListManager_listManagerContent__csMxt {
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(0.4,0,0.2,1), opacity 0.3s cubic-bezier(0.4,0,0.2,1);
  max-height: 1000px;
  opacity: 1;
}

.ListManager_listManagerContentClosed__QrHBV {
  max-height: 0;
  opacity: 0;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ListManager/ListManager.module.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,6FAA6F;EAC7F,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB","sourcesContent":["/* ボタンデザイン（ToolSettings.module.cssからコピー） */\r\n.button {\r\n  background: #1976d2;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 6px 18px;\r\n  font-size: 1em;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n.button:hover {\r\n  background: #1565c0;\r\n}\r\n.bulkDeleteButton {\r\n  background: #e53935;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 6px 18px;\r\n  font-size: 1em;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n  margin-left: 12px;\r\n}\r\n.bulkDeleteButton:disabled {\r\n  background: #f5bdbd;\r\n  color: #fff;\r\n  cursor: not-allowed;\r\n}\r\n.bulkDeleteButton:hover:not(:disabled) {\r\n  background: #b71c1c;\r\n}\r\n.deleteButton {\r\n  background: #e53935;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 4px 14px;\r\n  font-size: 1em;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n  margin-left: 8px;\r\n}\r\n.deleteButton:hover {\r\n  background: #b71c1c;\r\n}\r\n.listManagerContent {\r\n  overflow: hidden;\r\n  transition: max-height 0.3s cubic-bezier(0.4,0,0.2,1), opacity 0.3s cubic-bezier(0.4,0,0.2,1);\r\n  max-height: 1000px;\r\n  opacity: 1;\r\n}\r\n\r\n.listManagerContentClosed {\r\n  max-height: 0;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `ListManager_button__I5HIN`,
	"bulkDeleteButton": `ListManager_bulkDeleteButton__wQBHb`,
	"deleteButton": `ListManager_deleteButton__yPXTr`,
	"listManagerContent": `ListManager_listManagerContent__csMxt`,
	"listManagerContentClosed": `ListManager_listManagerContentClosed__QrHBV`
};
export default ___CSS_LOADER_EXPORT___;
